module.exports = __webpack_public_path__ + "img/quran-icon.f20e6cbd.png";